// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3rlZ-","subheader":"ReorderModal_subheader__1D0Vn","listWrap":"ReorderModal_listWrap__R5udJ"};